module.exports = __webpack_public_path__ + "static/media/Museo-300.cb8c48f0.woff";